import { FiRefreshCw, FiLogIn } from 'react-icons/fi'

type Props = {
  open: boolean
  secondsLeft: number
  isRTL: boolean
  renewing: boolean
  onRenew: () => void
  onLogoutNow: () => void
}

function formatClock(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds))
  const m = Math.floor(s / 60)
  const r = s % 60
  return `${m}:${r.toString().padStart(2, '0')}`
}

export default function SessionExpiryModal({
  open,
  secondsLeft,
  isRTL,
  renewing,
  onRenew,
  onLogoutNow,
}: Props) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-[20000] flex items-center justify-center bg-black/50 p-4" role="alertdialog" aria-modal="true">
      <div
        className={`w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl ring-1 ring-slate-900/10 ${isRTL ? 'text-right' : 'text-left'}`}
      >
        <h2 className="text-lg font-bold text-slate-900">
          {isRTL ? 'ستنتهي الجلسة قريباً' : 'Your session is about to expire'}
        </h2>
        <p className="mt-2 text-sm text-slate-600">
          {isRTL
            ? 'للاستمرار بدون انقطاع، جدّد الجلسة. إذا لم تفعل، سيتم تسجيل خروجك تلقائياً.'
            : 'Renew your session to keep working. If you do nothing, you will be signed out automatically.'}
        </p>
        <div className="mt-6 flex flex-col items-center justify-center rounded-xl bg-amber-50 px-4 py-6 border border-amber-200">
          <p className="text-sm font-medium text-amber-900">{isRTL ? 'الوقت المتبقي' : 'Time remaining'}</p>
          <p className="mt-1 font-mono text-4xl font-bold tabular-nums text-amber-950">{formatClock(secondsLeft)}</p>
        </div>
        <div className={`mt-6 flex flex-col gap-3 sm:flex-row ${isRTL ? 'sm:flex-row-reverse' : ''}`}>
          <button
            type="button"
            disabled={renewing}
            onClick={onRenew}
            className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-emerald-600 px-4 py-3 text-sm font-semibold text-white shadow hover:bg-emerald-700 disabled:opacity-60"
          >
            <FiRefreshCw className={renewing ? 'animate-spin' : ''} />
            {renewing ? (isRTL ? 'جاري التجديد…' : 'Renewing…') : isRTL ? 'تجديد الجلسة' : 'Renew session'}
          </button>
          <button
            type="button"
            disabled={renewing}
            onClick={onLogoutNow}
            className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm font-semibold text-slate-800 hover:bg-slate-50"
          >
            <FiLogIn />
            {isRTL ? 'تسجيل الخروج الآن' : 'Sign out now'}
          </button>
        </div>
      </div>
    </div>
  )
}
